import { IconDefinition } from "./types";

const arrowDownToLine: IconDefinition = {
  iconName: "arrow-down-to-line",
  width: 384,
  height: 512,
  svgPathData:
    "M360 512l24 0 0-48-384 0 0 48 360 0zM175 377l17 17 17-17 136-136 17-17-33.9-33.9-17 17-95 95 0-302.1-48 0 0 302.1-95-95-17-17-33.9 33.9 17 17 136 136z",
  iconType: "fill",
  fill: "none",
  fontAwesomeName: "arrow-down-to-line",
  unicode: 0xf33d,
};

export { arrowDownToLine };
